<template>
    <div>
        <section v-if="!initialLoading">
            <div class="row">
                <div class="col-12">
                    <div class="table-responsive">
                        <table
                            id="data-table-list-courses"
                            class="table-hover-animation table-striped table-bordered"
                        >
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Nombre</th>
                                    <th>Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="course in this.courses"
                                    v-bind:key="course.id"
                                >
                                    <td>
                                        <p style="width: 15px">
                                            {{ course.id }}
                                        </p>
                                    </td>
                                    <td>
                                        <p style="width: 220px">
                                            {{ course.name }}
                                        </p>
                                    </td>
                                    <td>
                                        <select
                                            v-model="optionSelected"
                                            @change="getOptionSelected(course)"
                                            id="item"
                                        >
                                            <option value="" disabled selected>
                                                Seleccione una acción
                                            </option>
                                            <option
                                                v-for="item in options"
                                                :value="item.value"
                                            >
                                                {{ item.label }}
                                            </option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
        <custom-spinner v-else></custom-spinner>

        <custom-modal
            id="edit-course-modal"
            color="primary"
            size="large"
            v-if="courseSelected"
        >
            <template #title
                >Editar curso <u> {{ courseSelected.name }} </u></template
            >

            <template #body>
                <form-course-edit :course="courseSelected"></form-course-edit>
            </template>
        </custom-modal>

        <custom-modal id="delete-course-modal" color="danger">
            <template #title
                >Borrar curso <u> {{ courseSelected.name }} </u></template
            >
            <template #body>¿Seguro que desea eliminar este Iso?</template>
            <template #footer>
                <button
                    type="button"
                    class="btn btn-primary"
                    data-dismiss="modal"
                >
                    Cancelar
                </button>
                <button
                    type="button"
                    class="btn btn-danger"
                    @click="deleteCourse(courseSelected.id)"
                >
                    Eliminar
                </button>
            </template>
        </custom-modal>
    </div>
</template>
<script>
import moment from "moment";
import ModalComponent from "../ModalComponent.vue";
import CustomSpinner from "../../common/custom-spinner/CustomSpinner.vue";
import language from "../../api/traduction_es";
import CourseEdit from "./isosEdit.vue";

export default {
    props: {
        user: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            initialLoading: false,
            moment: moment,
            courses: [],
            categories: [],
            levels: [],
            options: [
                {
                    value: "1",
                    label: "Editar",
                },
                {
                    value: "2",
                    label: "Eliminar",
                },
            ],
            optionSelected: "",
            courseSelected: {},
        };
    },
    components: {
        "custom-modal": ModalComponent,
        "custom-spinner": CustomSpinner,
        "form-course-edit": CourseEdit,
    },

    mounted() {
        this.listCourses();
        this.listCategories();
        /*  this.listCategories();
    this.listLevels();  */
    },

    methods: {
        loadDataTable() {
            $(document).ready(function () {
                $("#data-table-list-courses").DataTable(language);
            });
        },

        listCourses: function () {
            this.initialLoading = true;
            axios.get(`/isos/list`).then((response) => {
                this.courses = response.data;
                this.initialLoading = false;
                this.loadDataTable();
            });
        },

        listCategories() {
            axios
                .get(`/productos/tipo-producto`)
                .then((response) => {
                    if (response.data.error) {
                        this.message = "Sin categorias registradas";
                    } else {
                        Object.keys(response.data).map((key) => {
                            this.categories.push(response.data[key]);
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        listLevels() {
            axios
                .get(`/course/levels`)
                .then((response) => {
                    if (response.data.error) {
                        this.message = "Sin niveles registrados";
                    } else {
                        Object.keys(response.data).map((key) => {
                            this.levels.push(response.data[key]);
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        async deleteCourse(course_id) {
            const { data } = await axios.delete(`/isos/delete/${course_id}`);
            const { status, courses } = await data;
            const response =
                (await status) == "ok"
                    ? this.$message.success(
                          "Se ha eliminado el iso correctamente"
                      )
                    : await this.$message.success(
                          "Se ha eliminado el iso correctamente"
                      );

            if (!courses || courses.length == 0) {
                this.courses = [];
            }

            $("#delete-course-modal").modal("hide");
        },

        /**
         * Return data about the option selected in the table
         * @param {object} course - The course object selected
         */
        getOptionSelected(course) {
            // La opcion se recupera de la variable optionSelected
            let option = this.optionSelected;

            switch (option) {
                case "1":
                    this.courseSelected = course;
                    $("#edit-course-modal").modal("show");
                    this.optionSelected = "";
                    break;
                case "2":
                    this.courseSelected = course;
                    $("#delete-course-modal").modal("show");
                    this.optionSelected = "";
                    break;
            }
        },

        /**
         * 0 -> registrado e inactivo
         * 1 -> en espera
         * 2 -> activo
         */
        async sendRequest(id) {
            const data = await axios.post(`/course/${id}/sendRequest`);

            switch (data.data) {
                case "ok":
                    this.$message.success(
                        "Curso enviado a revisión correctamente"
                    );
                    break;
                case "request":
                    this.$message.warning(
                        "Ya se ha enviado el curso para su revisión"
                    );
                    break;
                case "empty":
                    this.$message.warning(
                        "El curso debe tener al menos un módulo y una clase"
                    );
                    break;
                case "misconfigured":
                    this.$message.warning(
                        "Configure la entrega del certificado"
                    );
                    break;
                case "signaturetemplate":
                    this.$message.warning(
                        "Seleccione la plantilla y firma para el certificado"
                    );
                    break;
                default:
                    this.$message.warning("Error al validar datos");
                    break;
            }
            this.listCourses();
        },
    },
};
</script>
<style>
.el-select {
    width: 80%;
}
.el-select .el-input .el-select__caret::before {
    content: "\e794";
}

#customize_select {
    background-color: #ffffff !important;
    border: none !important;
    width: 0px !important;
    font-size: 0px !important;
    justify-content: center;
    text-align: center;
    padding: 0 !important;
}
</style>
